var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThumbnail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none",
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9.757 0v1.25H1.248v12.5h12.483v-8.5h1.248v8.5a1.2 1.2 0 01-.374.875c-.25.25-.541.375-.874.375H1.248c-.333 0-.624-.125-.874-.375A1.2 1.2 0 010 13.75V1.25A1.2 1.2 0 01.374.375C.624.125.915 0 1.248 0h8.51zm3.558 0v1.688H15v1.25h-1.685v1.687h-1.248V2.937H10.38v-1.25h1.686V0h1.248zM2.497 11.625h9.986l-2.996-4-2.642 3.48L4.889 8.52l-2.392 3.104zM1.248 1.25v12.5-12.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbnail);
export default __webpack_public_path__ + "static/media/thumbnail.63fb77f1c657e404205984a313f4fadd.svg";
export { ForwardRef as ReactComponent };